export const applyFiltersCalendar = (actions = {}) => ({
  type: 'APPLY_FILTERS_CALENDAR',
  actions
})